import View from '@/components/main/view';
const { Code, Welcome, EnterSend, StaffSend, Dynamic, Chat, WordHelp, CodeHelp } = require('./page').default;
const Wait = () => import('@/views/wait.vue');
const Home = () => import('@/views/home.vue');
const GroupTool = () => import('@/views/marketing/groupTool.vue');
const Tag = () => import('@/views/client/tag.vue');
const GroupChat = () => import('@/views/client/groupChat.vue');
const Customer = () => import('@/views/client/customer.vue');
const LostCustomer = () => import('@/views/client/lostCustomer.vue');
const Material = () => import('@/views/material/material.vue');
const Setting = () => import('@/views/system/setting.vue');

const routers = [
  {
    path: '/home',
    name: 'home',
    component: Home,
    meta: {
      icon: 'home',
      title: '首页',
      seoTitle: '机汇管家首页',
      showInMenu: true
    }
  },
  {
    path: '/marketing',
    name: 'marketing',
    component: View,
    meta: {
      icon: 'bar-chart',
      title: '客户营销',
      seoTitle: '机汇管家客户营销',
      showInMenu: true,
    },
    children: [
      {
        path: '/code',
        name: 'code',
        component: Code,
        meta: {
          title: '渠道码',
          seoTitle: '机汇管家渠道码',
          showInMenu: true
        }
      },
      {
        path: '/welcome',
        name: 'welcome',
        component: Welcome,
        meta: {
          title: '欢迎语',
          seoTitle: '机汇管家欢迎语',
          showInMenu: true
        }
      },
      {
        path: '/pull',
        name: 'pull',
        component: GroupTool,
        meta: {
          title: '拉群工具',
          seoTitle: '机汇管家拉群工具',
          showInMenu: true
        }
      },
      {
        path: '/code-help',
        name: 'code-help',
        component: CodeHelp,
        meta: {
          title: '员工码帮助文档',
          seoTitle: '员工码创建、使用说明',
          showInMenu: false
        }
      }
    ]
  },
  {
    path: '/client',
    name: 'client',
    component: View,
    meta: {
      icon: 'team',
      title: '客户管理',
      seoTitle: '机汇管家客户管理',
      showInMenu: true,
    },
    children: [
      {
        path: '/customer',
        name: 'customer',
        component: Customer,
        meta: {
          title: '客户列表',
          seoTitle: '机汇管家客户列表',
          showInMenu: true
        }
      },
      {
        path: '/group_chat',
        name: 'groupChat',
        component: GroupChat,
        meta: {
          title: '群列表',
          seoTitle: '机汇管家群列表',
          showInMenu: true
        }
      },
      {
        path: '/tag',
        name: 'tag',
        component: Tag,
        meta: {
          title: '客户标签',
          seoTitle: '机汇管家客户标签',
          showInMenu: true
        }
      },
      {
        path: '/resign',
        name: 'resign',
        component: Wait,
        meta: {
          title: '离职继承',
          seoTitle: '机汇管家离职继承',
          showInMenu: true
        }
      },
      {
        path: '/outflow',
        name: 'outflow',
        component: LostCustomer,
        meta: {
          title: '客户流失',
          seoTitle: '机汇管家客户流失',
          showInMenu: true
        }
      }
    ]
  },
  {
    path: '/message',
    name: 'message',
    component: View,
    meta: {
      icon: 'apartment',
      title: '消息群发',
      seoTitle: '机汇管家消息群发',
      showInMenu: true,
    },
    children: [
      {
        path: '/enterprise',
        name: 'enterprise',
        component: EnterSend,
        meta: {
          title: '企业群发',
          seoTitle: '机汇管家企业群发',
          showInMenu: true
        }
      },
      {
        path: '/employee',
        name: 'employee',
        component: Wait,
        meta: {
          title: '员工群发',
          seoTitle: '机汇管家员工群发',
          showInMenu: true
        }
      }
    ]
  },
  {
    path: '/chat',
    name: 'chat',
    component: View,
    meta: {
      icon: 'tool',
      title: '聊天工具',
      seoTitle: '机汇管家聊天工具',
      showInMenu: true,
    },
    children: [
      {
        path: '/character',
        name: 'character',
        component: Wait,
        meta: {
          title: '客户画像',
          seoTitle: '机汇管家客户画像',
          showInMenu: true
        }
      },
      {
        path: '/word',
        name: 'word',
        component: Chat,
        meta: {
          title: '聊天话术',
          seoTitle: '机汇管家聊天话术',
          showInMenu: true
        }
      },
      {
        path: '/word-help',
        name: 'word-help',
        component: WordHelp,
        meta: {
          title: '配置聊天工具栏',
          seoTitle: '机汇管家配置聊天工具栏',
          showInMenu: false
        }
      }
    ]
  },
  {
    path: '/circle',
    name: 'circle',
    component: View,
    meta: {
      icon: 'chrome',
      title: '企业朋友圈',
      seoTitle: '机汇管家企业朋友圈',
      showInMenu: true,
    },
    children: [
      {
        path: '/information',
        name: 'information',
        component: Wait,
        meta: {
          title: '动态管理',
          seoTitle: '机汇管家动态管理',
          showInMenu: true
        }
      }
    ]
  },
  {
    path: '/material',
    name: 'material',
    component: View,
    meta: {
      icon: 'appstore',
      title: '素材管理',
      seoTitle: '机汇管家素材管理',
      showInMenu: true,
    },
    children: [
      {
        path: '/materials',
        name: 'materials',
        component: Material,
        meta: {
          title: '企业素材',
          seoTitle: '机汇管家企业素材',
          showInMenu: true
        }
      }
    ]
  },
  {
    path: '/system',
    name: 'system',
    component: View,
    meta: {
      icon: 'setting',
      title: '系统管理',
      seoTitle: '机汇管家系统管理',
      showInMenu: true,
    },
    children: [
      {
        path: '/setting',
        name: 'setting',
        component: Setting,
        meta: {
          title: '系统设置',
          seoTitle: '机汇管家系统设置',
          showInMenu: true
        }
      }
    ]
  },
  {
    path: '/home',
    name: 'applet',
    meta: {
      icon: 'shop',
      title: '小程序商城',
      seoTitle: '小程序商城',
      href: 'https://www.jihuik.com',
      showInMenu: true,
    }
  },
  {
    path: '/home',
    name: 'crm',
    meta: {
      icon: 'deployment-unit',
      title: '智能CRM',
      seoTitle: '智能CRM',
      href: 'http://www.jihuicrm.com',
      showInMenu: true,
    },
  }
];

export default routers;
